import {
  AUTO_EQUIPPED_CATEGORIES,
} from 'constants/autoEquippedCategories';
import {
  fetchMyself,
  fetchOutfit,
  updateMyself,
} from 'actions/myself';

export default function processStandardMessages(standardMessages) {
  return (dispatch) => {

    // TODO: If we have undergone some kind of big-time equippable change, then it's time
    // to do an entire re-fetch of /outfits, because we can't propagate Destinies, etc.,
    // properly
    if (standardMessages.some(({ category }) => AUTO_EQUIPPED_CATEGORIES.includes(category))) {
      dispatch(fetchMyself());
      dispatch(fetchOutfit());
      return;
    }

    // Update Myself and Possessions if necessary
    dispatch(updateMyself(standardMessages));
  };
}